import { gql } from '@apollo/client';

export const USERS = gql`
  query usersAdminAosStreams($filters: AdminSearchInput) {
    users(filters: $filters) {
      count
      users {
        id
        displayName
      }
    }
  }
`;

export const STREAMS = gql`
  query Streams($filters: StreamFiltersInput) {
    streams(filters: $filters) {
      streams {
        id
        name
        isActive
        streamLeadId
        deliveryManagerId
        streamLead {
          id
          firstName
          lastName
        }
        deliveryManager {
          id
          firstName
          lastName
        }
        createdAt
        updatedAt
      }
      count
    }
  }
`;
